import { baseClient, API, authClient } from '../../utils/index';

export const createAppraisal = async (data) => {
	return baseClient().post(`${API}/appraisals/add`, data);
};
